import type { LocaleMessages, CourseAdmin } from 'shared-types';

type CourseAdminPermissions = CourseAdmin['permissions'];
type LabelByPermission = Record<CourseAdminPermissions[number], string>;

interface Params {
  messages?: LocaleMessages;
}

// overloads
function getUserPermissions(
  params: Params & { messages: LocaleMessages }
): LabelByPermission;
function getUserPermissions(
  params: Params & { messages?: never }
): CourseAdminPermissions;

// implementation
function getUserPermissions({
  messages
}: Params): LabelByPermission | CourseAdminPermissions {
  if (messages) {
    return {
      'edit-content': messages.settingsPermissionEditContent,
      'edit-settings': messages.settingsPermissionEditSettings,
      'manage-users': messages.settingsPermissionManageUsers,
      'review-tasks': messages.settingsPermissionReviewTasks,
      'view-analytics': messages.settingsPermissionViewAnalytics,
      'view-feedback': messages.settingsPermissionViewFeedback
    } satisfies LabelByPermission;
  }

  return [
    'edit-content',
    'edit-settings',
    'manage-users',
    'review-tasks',
    'view-analytics',
    'view-feedback'
  ] as const satisfies CourseAdminPermissions;
}

export default getUserPermissions;
